import { ARTICLE_VIEW_PARAM } from 'components/ArticleViewSelect/types'
import { useLocation } from 'react-router-dom'
import { ArticleView } from 'types'
import { useCallback } from 'react'

export const useLayerLocation = () => {
  const { search, pathname } = useLocation()

  return useCallback(
    (layerId: string) => {
      const searchParams = new URLSearchParams(search)
      searchParams.set('layer', layerId)
      searchParams.set(ARTICLE_VIEW_PARAM, ArticleView.Editing)

      return {
        pathname,
        search: searchParams.toString(),
      }
    },
    [search, pathname],
  )
}
